export default {
      id: "steps-arrows-red-usage",
      viewBox: "0 0 47 57",
      url: __webpack_public_path__ + "sprite.svg#steps-arrows-red",
      toString: function () {
        return this.url;
      }
    }